import {Tooltip} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { SelectHelper } from '../DataEntry/utils/helper';

/**
 * - title: String (required) tooltip text, unspecified will follow children's DOM
 * Passed through restProps:
 * - mouseEnterDelay: number (optional), unspecified will delay by 0.25 second (specified in defaultProps)
 * - placement: String (optional)
 */
function BukkuTooltip(props) {
    const {
        title,
        popupType,
        popupContainerId,
        tooltipRef,
        children,
        ...restProps
    } = props;

    // const popup = useRef(null);
    // popup.current = SelectHelper.getPopupContainer(popupContainerId, popupType);

    // // to prevent getting null popupContainer before DOM is fully loaded
    // useEffect(() => {
    //     popup.current = SelectHelper.getPopupContainer(popupContainerId, popupType);
    // }, [popupContainerId, popupType]);
    return (
        <Tooltip
            title={title || children}
            // getPopupContainer={
            //     trigger => SelectHelper.getCurriedPopupContainer(popupContainerId, popupType)(trigger)
            // }
            getPopupContainer={SelectHelper.getPopupContainer(popupContainerId)}
            ref={tooltipRef}
            {...restProps}
        >
            {children}
        </Tooltip>
    );
}

BukkuTooltip.propTypes = {
    mouseEnterDelay: PropTypes.number,
    placement: PropTypes.string,
};

BukkuTooltip.defaultProps = {
    mouseEnterDelay: 0.25,
    // placement: 'topLeft',
};

export default BukkuTooltip;
